export const types = {
	INIT_DOCUMENTS: "INIT_FORM12_DOCUMENTS",
	ADD_DOCUMENT: "ADD_FORM12_DOCUMENT",
	REMOVE_DOCUMENT: "REMOVE_FORM12_DOCUMENT",
	RESET_DOCUMENTS: "RESET_FORM12_DOCUMENTS",
}

export const initForm12Docs = (documents) => {
	return (dispatch) => dispatch({
		type: types.INIT_DOCUMENTS,
		payload: documents
	})
}

export const addForm12Doc = (docData) => {
	return (dispatch) => dispatch({
		type: types.ADD_DOCUMENT,
		payload: docData
	})
}

export const removeForm12Doc = (docId) => {
	return (dispatch) => dispatch({
		type: types.REMOVE_DOCUMENT,
		payload: docId
	})
}

export const resetForm12Docs = () => {
	return (dispatch) => dispatch({
		type: types.RESET_DOCUMENTS,
	})
}
